import { useUrlQuery } from "hooks/localstate/url/useUrlQuery"
import { useRole } from "hooks/misc/useRole"

export function useAdminStorefront() {
  const role = useRole()
  const [admin] = useUrlQuery("admin")

  return admin !== undefined && role && role !== "none"
}
